export default {"src":"/_next/static/media/CertifiedImg.2671bccb.svg","height":108,"width":87,"blurWidth":0,"blurHeight":0};